import { ChangeDetectionStrategy, Component, inject, Input } from '@angular/core';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { faColumns, faMinus, faTimes } from '@fortawesome/pro-regular-svg-icons';
import { ModalWindowController } from '@reconcept-platform/shared/ui/core/modal';
import { ButtonIconOnlyComponent } from '../../button';

@Component({
  selector: 'rcp-modal-header',
  styleUrls: ['./modal-header.component.scss'],
  template: `
    <div class="rcp-modal-header print-value" [class.small]="size === 'small'">
      <div class="title-bar">
        <div class="modal-header-title">
          <h1 class="ellipsis">{{ title }}</h1>
          <span class="modal-header-after-title global-component-style-flex-gap-inline">
            <ng-content select="[after-title]"></ng-content>
          </span>
        </div>

        <div class="modal-header-actions global-component-style-flex-gap">
          <ng-content select="[actions]"></ng-content>

          @if (showCompare) {
            <rcp-button-icon-only (click)="clickToggleDisplayMinimizedToCompare($event)" [icon]="faColumns" />
          }

          @if (showMinimize) {
            <rcp-button-icon-only (click)="clickToggleDisplayMinimized($event)" [icon]="faMinus" />
          }

          @if (showCloseButton) {
            <rcp-button-icon-only [icon]="faTimes" (click)="closeModal()" />
          }
        </div>
      </div>
      @if (description) {
        <div class="modal-header-description">
          {{ description }}
        </div>
      }

      <ng-content select="[action-link]"></ng-content>
    </div>
  `,
  imports: [FontAwesomeModule, ButtonIconOnlyComponent],
  changeDetection: ChangeDetectionStrategy.Eager,
})
export class ModalHeaderComponent {
  private modalWindowController = inject(ModalWindowController, { optional: true });

  @Input() title: string;
  @Input() description: string;
  @Input() showCloseButton = true;
  @Input() size: 'small' | 'normal' = 'normal';

  protected readonly faTimes = faTimes;

  get showMinimize() {
    // @ts-expect-error TS2531 object possibly null
    return this.modalWindowController.isMinimizedAllowed();
  }

  get showCompare() {
    // @ts-expect-error TS2531 object possibly null
    return this.modalWindowController.isCompareAllowed();
  }

  closeModal() {
    // close this modal
    this.modalWindowController?.dismiss();
  }

  clickToggleDisplayMinimized($event: MouseEvent) {
    // stop propagation to prevent background click
    $event.stopPropagation();

    // every other action then compare, means we want to stop comparing
    // @ts-expect-error TS2531 object possibly null
    this.modalWindowController.setComparingMode(false);

    // @ts-expect-error TS2531 object possibly null
    this.modalWindowController.toggleDisplayMinimized();
  }

  clickToggleDisplayMinimizedToCompare($event: MouseEvent) {
    $event.stopPropagation();

    // @ts-expect-error TS2531 object possibly null
    this.modalWindowController.title.set(this.title);
    // @ts-expect-error TS2531 object possibly null
    this.modalWindowController.setComparingMode(true);
    // @ts-expect-error TS2531 object possibly null
    this.modalWindowController.toggleDisplayMinimized();
  }

  protected readonly faMinus = faMinus;
  protected readonly faColumns = faColumns;
}
